export default {
  // 右側菜單項
  menuItems: {
    nodeNote: {
      text: "備註節點",
      shortcut: "alt+V/⌥+V",
    },
    copyAddress: {
      text: "複製地址",
      shortcut: "ctrl+C/⌘+C",
    },
    addCanvas: {
      text: "新建畫布",
      shortcut: "alt+G/⌥+G",
    },
    deleteNode: {
      text: "刪除節點",
      shortcut: "Delete",
    },
    labelSetting: {
      text: "標籤設置",
      submenu: {
        addLabel: "添加標籤",
        editLabel: "編輯標籤",
        deleteLabel: "刪除標籤",
      },
    },
    addSurvey: {
      text: "加入調證",
      submenu: {
        ordinarySurvey: "普通調證",
        keySurvey: "重點調證",
      },
    },
    addMonitor: {
      text: "加入監控",
      shortcut: "ctrl+M/⌘+M",
    },
    addBoard: {
      text: "加入看板",
    },
  },
};
